module.exports = __webpack_public_path__ + "media/images/athletes/3704-793906e713c5dc90836d6d321538f0c9.png";